import { render, staticRenderFns } from "./index.vue?vue&type=template&id=465675e3"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=465675e3&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\.jenkins\\workspace\\tplt.10ndata.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('465675e3')) {
      api.createRecord('465675e3', component.options)
    } else {
      api.reload('465675e3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=465675e3", function () {
      api.rerender('465675e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wangEditor/index.vue"
export default component.exports